export type V4SceneId = 'conversational' | 'adaptive' | 'mobile';

/*
 * Timing is the approved prototype's, unchanged: one 34.5s loop driven by the
 * registered property --v4T. --v4t is the second, slower clock the product
 * surface runs on; V4_KEYS is the same piecewise map the prototype uses, kept
 * here so the no-@property fallback driver can reproduce it in JS.
 */
export const V4_DURATION_S = 34.5;

/** Settled frame shown under reduced motion and before the clock starts. */
export const V4_POSTER_T = 10.2;
export const V4_POSTER_t = 11.71;

export const V4_KEYS: readonly [number, number][] = [
  [0, 0],
  [1.8, 3],
  [3.1, 5.8],
  [7.5, 10.4],
  [8.5, 13.2],
  [13.9, 19.4],
  [14.8, 20.2],
  [16.3, 22.3],
  [19.3, 24.3],
  [23.5, 25.5],
  [34.5, 26],
];

export interface V4Act {
  id: V4SceneId;
  index: string;
  label: string;
  headline: string;
  body: string;
  /** --v4T at which each copy line starts arriving, staggered as in the prototype. */
  in: readonly [number, number, number, number];
  /** --v4T at which each line starts leaving. */
  out: readonly [number, number, number, number];
  /** Progress bar window: [start, span] on --v4T. */
  prog: readonly [number, number];
}

/* Copy and stagger lifted from the prototype's left rail. */
export const V4_ACTS: readonly V4Act[] = [
  {
    id: 'conversational',
    index: '01',
    label: 'Conversational Cue',
    headline: 'Ask Cue anything.',
    body: 'Employees can ask Cue questions, get responses tailored to them, and take action directly.',
    in: [0.7, 0.78, 0.86, 0.96],
    out: [14.5, 14.54, 14.58, 14.63],
    prog: [0, 14.9],
  },
  {
    id: 'adaptive',
    index: '02',
    label: 'Adaptive Cue',
    headline: 'An intranet that adapts.',
    body: 'Each employee’s intranet adapts to them with the help of AI, changing based on role, location, needs, and individual priorities.',
    in: [15.1, 15.18, 15.26, 15.36],
    out: [23.2, 23.24, 23.28, 23.33],
    prog: [14.9, 8.6],
  },
  {
    id: 'mobile',
    index: '03',
    label: 'Mobile Cue',
    headline: 'Cue goes with them.',
    body: 'Employees can take Cue with them anywhere on their mobile device.',
    in: [23.9, 23.98, 24.06, 24.16],
    out: [33.9, 33.94, 33.98, 34.03],
    prog: [23.5, 11.0],
  },
];

/** Reveal window length for a copy line arriving / leaving, in --v4T units. */
export const COPY_IN_S = 0.5;
export const COPY_OUT_S = 0.38;
